import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import KakobuySpreadsheetPoradnik from "@/pages/article/kakobuy-spreadsheet-poradnik/page";
import KakobuyBezpieczneZakupy from "@/pages/article/kakobuy-bezpieczne-zakupy/page";
import KakobuyNajlepszeSneakersy from "@/pages/article/kakobuy-najlepsze-sneakersy-2026/page";
import KakobuyStreetwearPoradnik from "@/pages/article/kakobuy-streetwear-poradnik/page";
import KakobuyNajlepszeZnajdzki from "@/pages/article/kakobuy-najlepsze-znajdzki/page";
import KakobuyJakZamawiac from "@/pages/article/kakobuy-jak-zamawiac-z-chin/page";
import KakobuyAgentPoradnik from "@/pages/article/kakobuy-agent-zakupowy-poradnik/page";
import KakobuyTanieProdukty from "@/pages/article/kakobuy-tanie-produkty-pod-100-pln/page";
import KakobuyMarkiPremium from "@/pages/article/kakobuy-marki-premium-lista/page";
import KakobuyWysylkaPolska from "@/pages/article/kakobuy-wysylka-do-polski/page";
import KakobuyZdjeciaQC from "@/pages/article/kakobuy-zdjecia-qc-poradnik/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-poradnik",
    element: <KakobuySpreadsheetPoradnik />,
  },
  {
    path: "/artykul/kakobuy-bezpieczne-zakupy",
    element: <KakobuyBezpieczneZakupy />,
  },
  {
    path: "/artykul/kakobuy-najlepsze-sneakersy-2026",
    element: <KakobuyNajlepszeSneakersy />,
  },
  {
    path: "/artykul/kakobuy-streetwear-poradnik",
    element: <KakobuyStreetwearPoradnik />,
  },
  {
    path: "/artykul/kakobuy-najlepsze-znajdzki",
    element: <KakobuyNajlepszeZnajdzki />,
  },
  {
    path: "/artykul/kakobuy-jak-zamawiac-z-chin",
    element: <KakobuyJakZamawiac />,
  },
  {
    path: "/artykul/kakobuy-agent-zakupowy-poradnik",
    element: <KakobuyAgentPoradnik />,
  },
  {
    path: "/artykul/kakobuy-tanie-produkty-pod-100-pln",
    element: <KakobuyTanieProdukty />,
  },
  {
    path: "/artykul/kakobuy-marki-premium-lista",
    element: <KakobuyMarkiPremium />,
  },
  {
    path: "/artykul/kakobuy-wysylka-do-polski",
    element: <KakobuyWysylkaPolska />,
  },
  {
    path: "/artykul/kakobuy-zdjecia-qc-poradnik",
    element: <KakobuyZdjeciaQC />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;